import { render, staticRenderFns } from "./ApplicantMessageHistoryFromApplicant.vue?vue&type=template&id=57c7f06b"
import script from "./ApplicantMessageHistoryFromApplicant.vue?vue&type=script&lang=js"
export * from "./ApplicantMessageHistoryFromApplicant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports